import React, { Component , PropTypes } from "react";

import { StringHelper, _ } from '../../strings'

export class SupportedBrandSection extends Component {
	constructor(props) {
    super(props);
    this.state = {
    };
  }
	render() {
		const title = this.props.title
		const data = this.props.data

		var rows = []
		for(var i = 0; i < data.length; i++){
			rows.push(
				<tr className="tableBody" key={data[i].brand + "_" + data[i].model}>
					<td className="model">{data[i].model}</td>
					<td className="deviceType">{data[i].type}</td>
        	<td>{data[i].remarks}</td>
        </tr>
			);
		}
		const tbody = (<tbody>{rows}</tbody>)

		return (
			<section className="section-2 vertical-flex-item">
          <div className="device-type-container">
            <div className="title-group">
              <div className="title">{title}</div>
            </div>
            <div className="tableWrapper">
              <table className="deviceTable">
                <thead>
                  <tr className="tableHead">
                    <th className="model">{_("model")}</th><th className="deviceType">{_("device_type")}</th><th className="remarks">{_("remarks")}</th>
                  </tr>
                </thead>
								{tbody}
              </table>
            </div>
          </div>
        </section>
			)
		}

}
